export default {"src":"/_next/static/media/cross-hand.5dd224f2.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};